// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"9832ce63","369":"6d1c0b32","566":"6d1c0b32","638":"516e888a","666":"6d1c0b32","848":"e3f90e3f"}[chunkId] + ".chunk.css";
};